const FALLBACK = {
  DESTINATION_CITY: 'Select Destination City',
  DESTINATION_BRANCH: 'Select Destination Branch',
  MANUAL_LR: 'Please Enter Manual LR',
  SENDER_MOBILE: 'Enter Valid Sender Mobile number',
  SENDER_NAME: 'Enter Valid Sender Name',
  SENDER_PARTY: 'Select Sender Party',
  SENDER_ADDRESS: 'Enter Address',
  SENDER_GST: 'Enter Valid GST Number',
  EWAY_BILL: 'Enter Valid E-Way Bill No',
  EWAY_BILL_DUPLICATE: 'This E-Way No. Already Added, Please Add Another E-Way No.',
  BILL_NUMBER: 'Enter Valid Bill Number',
  BILL_AMOUNT: 'Enter Bill Amount',
  RECEIVER_MOBILE: 'Enter Valid Receiver Mobile number',
  RECEIVER_NAME: 'Enter Valid Receiver Name',
  RECEIVER_PARTY: 'Select Receiver Party',
  RECEIVER_ADDRESS: 'Enter Address',
  RECEIVER_GST: 'Enter Valid GST Number',
  CONSIGNMENT_TYPE: 'Select Consignment Type',
  PACK_EMTHOD: 'Select Pack Method',
  UNITS: 'Enter Units',
  GOOGS_VALUE: 'Enter Goods Value',
  WEIGHT_ACTUAL: 'Enter Weight Actual',
  WEIGHT_CHARGED: 'Enter Weight Charge',
  RATE: 'Enter Rate',
  FREIGHT: 'Freight Can not be Zero',
  COLLECTION_CARTAGE: 'Enter Colleection Cartage',
  DELIVERY_CARTAGE: 'Enter Drop Cartage',
  HAMALI: 'Enter Hamali',
  OPERATOR_HAMALI: 'Enter Operator Hamali',
  Valuation: 'Enter Valuation',
  DOCUMENT_CHARGE: 'Enter Document Charge',
  PICKUP_CHARGE: 'Enter Pickup Charge',
  DROPOFF_CHARGE: 'Enteer Drop Off Charge',
  CONSIGNMENT_DATA: 'Enter Consignment Data',
  RECIPIENT_NAME: 'Fill Recipient Name',
  RECIPIENT_CONTACT: 'Fill Recipient Contact No',
  RECIPIENT_CONTACT_LENGTH: 'Fill Valid Recipient Contact No',
  DELIVERY_REMARKS: 'Fill Delivery Remarks',
  CANCEL_REMARKS: 'Fill Cancel Remarks',
  REC_ID_PROOF: 'Fill ID Card Number',
  TRANSFER_TO_BRANCH: 'Select Transfer To Branch',
  TRANSFER_REASON: 'Fill Transfer Reason',
  TRANSFER_BY_VEHICLE: 'Select Transfer By Vehicle',
  SELECT_LR: 'Please Select LR',
  ENTER_CHALLAN_NUMBER: 'Enter Challan Number',
  SELECT_RECEIVE_TO_Branch: 'Select Received To Branch',
  SELECT_RECEIVE_DASH_Branch: 'Select Branch Wise',
  VEHICLE_NO: 'Select Vehicle To Dispatch',
  VEHICLE_NO_FORMAT: 'Enter valid vehicle No TN-46-AM-1234 OR TN-46-M-1234',
  SELECT_CROSSING_CITY: 'select Crossing City',
  SELECT_CROSSING_BRANCH: 'select Crossing City Branch',
  NO_TRIPS_IN_SELECTED: 'No Passenger Trip Has been Found, Please Select Another Vehicle!',
  CONFIGURE_MASTER_BUS_NUMBER: 'Configure MasterBus Number',
}

const pick = (value, key) => value || FALLBACK[key]

export const getValidationMessages = (translations = {}) => {
  const bs = translations.booking || {}
  const bt = translations.branchTransfer || {}
  const btr = translations.branchTransferReceive || {}
  const ds = translations.dispatch || {}
  const rs = translations.receive || {}
  const de = translations.delivery || {}

  return {
    DESTINATION_CITY: pick(bs.selectDestinationCity, 'DESTINATION_CITY'),
    DESTINATION_BRANCH: pick(bs.selectDestinationBranch, 'DESTINATION_BRANCH'),
    MANUAL_LR: pick(bs.pleaseEnterManualLr, 'MANUAL_LR'),
    SENDER_MOBILE: pick(bs.enterValidSenderMobileNumber, 'SENDER_MOBILE'),
    SENDER_NAME: pick(bs.enterValidSenderName, 'SENDER_NAME'),
    SENDER_PARTY: pick(bs.selectSenderParty, 'SENDER_PARTY'),
    SENDER_ADDRESS: pick(bs.enterAddress, 'SENDER_ADDRESS'),
    SENDER_GST: pick(bs.enterValidGstNumber, 'SENDER_GST'),
    EWAY_BILL: pick(bs.enterValidEwayBillNo, 'EWAY_BILL'),
    EWAY_BILL_DUPLICATE: pick(bs.ewayBillDuplicate, 'EWAY_BILL_DUPLICATE'),
    BILL_NUMBER: pick(bs.enterValidBillNumber, 'BILL_NUMBER'),
    BILL_AMOUNT: pick(bs.enterBillAmount, 'BILL_AMOUNT'),
    RECEIVER_MOBILE: pick(bs.enterValidReceiverMobileNumber, 'RECEIVER_MOBILE'),
    RECEIVER_NAME: pick(bs.enterValidReceiverName, 'RECEIVER_NAME'),
    RECEIVER_PARTY: pick(bs.selectReceiverParty, 'RECEIVER_PARTY'),
    RECEIVER_ADDRESS: pick(bs.enterAddress, 'RECEIVER_ADDRESS'),
    RECEIVER_GST: pick(bs.enterValidReceiverGstNumber, 'RECEIVER_GST'),
    CONSIGNMENT_TYPE: pick(bs.selectConsignmentType, 'CONSIGNMENT_TYPE'),
    PACK_EMTHOD: pick(bs.selectPackMethod, 'PACK_EMTHOD'),
    UNITS: pick(bs.enterUnits, 'UNITS'),
    GOOGS_VALUE: pick(bs.enterGoodsValue, 'GOOGS_VALUE'),
    WEIGHT_ACTUAL: pick(bs.enterWeightActual, 'WEIGHT_ACTUAL'),
    WEIGHT_CHARGED: pick(bs.enterWeightCharge, 'WEIGHT_CHARGED'),
    RATE: pick(bs.enterRate, 'RATE'),
    FREIGHT: pick(bs.freightCanNotBeZero, 'FREIGHT'),
    COLLECTION_CARTAGE: pick(bs.enterCollectionCartage, 'COLLECTION_CARTAGE'),
    DELIVERY_CARTAGE: pick(bs.enterDropCartage, 'DELIVERY_CARTAGE'),
    HAMALI: pick(bs.enterHamali, 'HAMALI'),
    OPERATOR_HAMALI: pick(bs.enterOperatorHamali, 'OPERATOR_HAMALI'),
    Valuation: pick(bs.enterValuation, 'Valuation'),
    DOCUMENT_CHARGE: pick(bs.enterDocumentCharge, 'DOCUMENT_CHARGE'),
    PICKUP_CHARGE: pick(bs.enterPickupCharge, 'PICKUP_CHARGE'),
    DROPOFF_CHARGE: pick(bs.enterDropOffCharge, 'DROPOFF_CHARGE'),
    CONSIGNMENT_DATA: pick(bs.enterConsignmentData, 'CONSIGNMENT_DATA'),
    RECIPIENT_NAME: pick(de.fillRecipientName, 'RECIPIENT_NAME'),
    RECIPIENT_CONTACT: pick(de.fillRecipientContactNo, 'RECIPIENT_CONTACT'),
    RECIPIENT_CONTACT_LENGTH: pick(de.fillValidRecipientContactNo, 'RECIPIENT_CONTACT_LENGTH'),
    DELIVERY_REMARKS: pick(de.fillDeliveryRemarks, 'DELIVERY_REMARKS'),
    CANCEL_REMARKS: pick(de.fillCancelRemarks, 'CANCEL_REMARKS'),
    REC_ID_PROOF: pick(de.fillIdCardNumber, 'REC_ID_PROOF'),
    TRANSFER_TO_BRANCH: pick(bt.selectTransferToBranch, 'TRANSFER_TO_BRANCH'),
    TRANSFER_REASON: pick(bt.fillTransferReason, 'TRANSFER_REASON'),
    TRANSFER_BY_VEHICLE: pick(bt.selectTransferByVehicle, 'TRANSFER_BY_VEHICLE'),
    SELECT_LR: pick(bt.pleaseSelectLr || btr.pleaseSelectLr || ds.pleaseSelectLr || rs.pleaseSelectLr, 'SELECT_LR'),
    ENTER_CHALLAN_NUMBER: pick(bt.enterChallanNumber || ds.enterChallanNumber, 'ENTER_CHALLAN_NUMBER'),
    SELECT_RECEIVE_TO_Branch: pick(btr.selectReceivedToBranch || rs.selectReceivedToBranch, 'SELECT_RECEIVE_TO_Branch'),
    SELECT_RECEIVE_DASH_Branch: pick(ds.selectBranchWise, 'SELECT_RECEIVE_DASH_Branch'),
    VEHICLE_NO: pick(ds.selectVehicleToDispatch, 'VEHICLE_NO'),
    VEHICLE_NO_FORMAT: pick(ds.enterValidVehicleNo, 'VEHICLE_NO_FORMAT'),
    SELECT_CROSSING_CITY: pick(ds.selectCrossingCity, 'SELECT_CROSSING_CITY'),
    SELECT_CROSSING_BRANCH: pick(ds.selectCrossingBranch, 'SELECT_CROSSING_BRANCH'),
    NO_TRIPS_IN_SELECTED: pick(ds.noTripsInSelectedVehicle, 'NO_TRIPS_IN_SELECTED'),
    CONFIGURE_MASTER_BUS_NUMBER: pick(ds.configureMasterBusNumber, 'CONFIGURE_MASTER_BUS_NUMBER'),
  }
}
